<template>
    <a class="has-text-grey-light is-size-7" slot="trigger">
      <b-icon
          icon="magnify"
          size="is-small">
      </b-icon>
      Advanced Search Options
    </a>
</template>

<script>
export default {
  name: "AdvancedSearchOptionsLink",
}
</script>

<style scoped>

</style>